<template>
  <div id="reports-certificated" class="row">
    <div class="col-12">
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="reset" @keydown="form.onKeydown($event)">
        <v-container grid-list-xl>
          <v-toolbar flat :color="themeColor" dark>
            <v-toolbar-title>REPORTE DE VENCIMIENTO DE CERTIFICADOS</v-toolbar-title>
          </v-toolbar>
          <v-layout :id="ref" class="wrap justify-space-around form-body">
            <v-col lg="6" md="6" sm="6" cols="12">
              <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="form.dateStart" label="Fecha Inicio" readonly v-on="on" />
                </template>
                <v-date-picker :color="themeColor" v-model="form.dateStart" @input="startMenu = false" />
              </v-menu>
            </v-col>
            <v-col lg="6" md="6" sm="6" cols="12">
              <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="form.dateEnd" label="Fecha Fin" readonly v-on="on" />
                </template>
                <v-date-picker :color="themeColor" v-model="form.dateEnd" @input="endMenu = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-btn :color="themeColor" class="white--text" style="margin-right:50px;" @click="getLicences()">
                <i class="fas fa-file-download" /> Generar reporte
              </v-btn>
              <v-btn color="success" class="white--text" @click="downloadExcel()">
                <i class="fas fa-download" /> Descargar Excel
              </v-btn>
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <v-col v-if="dowloading" class="subtitle-1 text-center" cols="12">
      Cargando por favor espere...
    </v-col>
    <v-progress-linear indeterminate background-color="success" color="yellow darken-2" height="10"
      v-if="dowloading"></v-progress-linear>

    <div class="col-12">
      <v-data-table v-if="certificados != 0" :headers="headers" :items="certificados" class="elevation-1">
        <template v-slot:item.folios="{ item }">
          <span v-if="item.folios == null">0</span>
          <span v-else>{{ item.folios }}</span>
        </template>
        <template v-slot:item.tipo_certificado="{ item }">
          <span v-if="item.tipo_certificado === '01' || item.tipo_certificado === 1">Firma</span>
          <span v-else-if="item.tipo_certificado === '02' || item.tipo_certificado === 2">Transmisión</span>
          <span v-else>{{ item.tipo_certificado }}</span>
        </template>
        <template v-slot:item.fecha_inicio="{ item }">
          <span v-if="item.fecha_inicio === null">Ninguna</span>
          <span v-else>{{ item.fecha_inicio }}</span>
        </template>
        <template v-slot:item.fecha_fin="{ item }">
          <span v-if="item.fecha_fin === null">Ninguna</span>
          <span v-else>{{ item.fecha_fin }}</span>
        </template>
        <template v-slot:item.active="{ item }">
          <span v-if="item.active === 1">Activo</span>
          <span v-else>Inactivo</span>
        </template>
      </v-data-table>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from 'vform';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('reportCertificates') };
  },
  data: () => ({
    form: new Form({
      dateStart: '',
      dateEnd: '',
      busy: false,
    }),
    apiURL: '/api/catalogs/getAllServices',
    valid: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      numeric: (v) => /^([0-9])*$/.test(v) || 'El campo solo permite caracteres numericos.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rucLength: (v) => ((v.length >= 5 && v.length <= 20) || v.length === 0) || 'El campo debe tener de 5 a 20 caracteres.',
      rucFormat: (v) => (/^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
        || v.length === 0) || 'El campo debe tener un formato válido.',
    },
    startMenu: false,
    endMenu: false,
    allHeaders: [{
      text: 'RUC Emp',
      value: 'identification_number',
      align: 'left',
      sortable: true,
    }, {
      text: 'Razón Social Emp',
      value: 'company_name',
      align: 'left',
      sortable: true,
    }, {
      text: 'Codigo de Sucursal',
      value: 'subsidiary_code',
      align: 'left',
      sortable: true,
    }, {
      text: 'Sucursal',
      value: 'subsidiary_description',
      align: 'left',
      sortable: true,
    }, {
      text: 'Tipo de Certificado',
      value: 'tipo_certificado',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha expiración',
      value: 'expiration_date',
      align: 'left',
      sortable: true,
    }],
    dowloading: false,
    value: 0,
    query: false,
    show: false,
    titulo: '',
    certificados: 0,
    headers: [],
  }),
  computed: {
    ref() {
      return this.form.id;
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
  },

  mounted() {
    this.form.dateStart = this.getDate();
    this.form.dateEnd = this.getDateEnd();
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.valid = true;
      }
    },

    getLicences() {
      this.validate();
      if (this.$refs.form.validate()) {
        this.dowloading = true;
        const url = '/api/report_expiration_certificate';
        this.form.post(url).then((response) => {
          this.certificados = response.data.items;
          this.headers = this.allHeaders;
          setTimeout(() => { this.dowloading = false; }, 500);
        })
          .catch(() => {
          });
      }
    },

    downloadExcel() {
      if (!this.certificados) {
        this.$store.dispatch('notifications/show', {
          message: 'El archivo Excel NO contiene registros que coincidan con los criterios de búsqueda.',
          type: 'error',
        });
      } else {
        this.dowloading = true;
        this.titulo = 'Reporte de Vencimiento de Certificados';
        const url = '/api/download_expiration_certificate/export';
        window.axios({
          method: 'post',
          url,
          responseType: 'arraybuffer',
          data: this.form,
        }).then((response) => {
          this.downloadFile(response, this.titulo);
          setTimeout(() => { this.dowloading = false; }, 1000);
        })
          .catch(() => {
          });
      }
    },

    downloadFile(response, filename) {
      const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename}.xlsx`;
      link.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    getDateEnd() {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      const y = date.getFullYear();
      const m = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const d = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
      const fecha = `${y}-${m}-${d}`;
      //  console.log(fecha);
      return fecha;
    },
    getDate() {
      const date = new Date();
      const y = date.getFullYear();
      const m = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const d = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
      const fecha = `${y}-${m}-${d}`;
      //  console.log(fecha);
      return fecha;
    },
  },
};
</script>
